import { useDispatch, useSelector } from "react-redux";
import {
  startLoading,
  initGifts,
  initGiftsActivated,
  stopLoading,
} from "redux/slices/giftSlice";
import axios from "axios";
import { API_URL } from "config";
// ----------------------------------------------------------------------

export default function useDataUser() {
  const dispatch = useDispatch();
  const { giftsActivated, gifts, isLoading, isLoaded } = useSelector(
    (state) => state.gift
  );

  return {
    gifts,
    giftsActivated,
    isLoaded,
    isLoading,
    getGiftsActivated: async () => {
      try {
        dispatch(startLoading());
        const res = await axios.get(`${API_URL.giftActivated}`);
        if (res && res.data) {
          dispatch(initGiftsActivated([...res.data]));
        } else {
          throw new Error("Cadeaux ne sont pas disponibles");
        }
      } catch (error) {
        dispatch(stopLoading());
        console.error();
        throw new Error("Cadeaux ne sont pas disponibles");
      }
    },
    getGifts: async () => {
      try {
        dispatch(startLoading());
        const res = await axios.get(API_URL.gift);
        if (res && res.data) {
          dispatch(initGifts([...res.data]));
        } else {
          throw new Error("Cadeaux ne sont pas disponibles");
        }
      } catch (error) {
        dispatch(stopLoading());
        console.error();
        throw new Error("Cadeaux ne sont pas disponibles");
      }
    },

    getGiftById: async (id) => {
      try {
        const res = await axios.get(API_URL.gift + "/" + id);
        if (res && res.data) {
          return res.data;
        } else {
          throw new Error("UsersData ne sont pas disponibles");
        }
      } catch (error) {
        console.error();
        throw new Error("Référentiels ne sont pas disponibles");
      }
    },
    saveGift: async (o) => {
      try {
        delete o.createdby;
        delete o.modifiedby;
        if (o && o.id) {
          const res = await axios.patch(API_URL.gift + "/" + o.id, o);
        } else {
          const res = await axios.post(API_URL.gift, o);
        }
      } catch (error) {
        dispatch(stopLoading());
        console.error();
        throw error;
      }
    },
    saveGiftFormData: async (o, formdata) => {
      try {
        dispatch(startLoading());
        delete o.modifiedby;
        delete o.createdby;
        if (o && o.id) {
          await axios.patch(API_URL.gift + "/formdata/" + o.id, formdata);
        } else {
          await axios.post(API_URL.gift + "/formdata", formdata);
        }
      } catch (error) {
        dispatch(stopLoading());
        console.error();
        throw error;
      }
    },
    delGift: async (o) => {
      try {
        dispatch(startLoading());
        if (o && o.id) {
          await axios.delete(API_URL.gift + "/" + o.id);
        }
      } catch (error) {
        dispatch(stopLoading());
        console.error();
        throw error;
      }
    },
    delImgFromGallery: async (o, img) => {
      try {
        dispatch(startLoading());
        if (o && o.id) {
          await axios.delete(API_URL.gift + "/" + o.id + "/galleryimg/" + img);
        }
      } catch (error) {
        dispatch(stopLoading());
        console.error();
        throw error;
      }
    },
    getStockByGift: async (idGift) => {
      try {
        const res = await axios.get(API_URL.giftStock + "/byGift/" + idGift);
        if (res && res.data) {
          return res.data;
        } else {
          throw new Error("UsersData ne sont pas disponibles");
        }
      } catch (error) {
        console.error();
        throw new Error("Référentiels ne sont pas disponibles");
      }
    },
    saveGiftStock: async (o) => {
      try {
        delete o.createdby;
        delete o.modifiedby;
        if (o && o.id) {
          const res = await axios.patch(API_URL.giftStock + "/" + o.id, o);
        } else {
          const res = await axios.post(API_URL.giftStock, o);
        }
      } catch (error) {
        dispatch(stopLoading());
        console.error();
        throw error;
      }
    },
    downloadGiftActivatedCsv: async () => {
      try {
        let res = null;
        let fileName = "";
        res = await axios.get(
          `${API_URL.giftActivated}/generated/download/csv`
        );
        fileName = "all_activated_code";
        if (res && res.data) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${fileName}_${new Date().getTime()}.csv`
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      } catch (error) {
        console.error();
        throw error;
      }
    },
    saveGiftActivated: async (o) => {
      try {
        delete o.createdby;
        delete o.modifiedby;
        const res = await axios.patch(API_URL.giftActivated + "/" + o.id, o);
      } catch (error) {
        dispatch(stopLoading());
        console.error();
        throw error;
      }
    },
    delGiftActivated: async (o) => {
      try {
        dispatch(startLoading());
        if (o && o.id) {
          await axios.delete(API_URL.giftActivated + "/" + o.id);
        }
      } catch (error) {
        dispatch(stopLoading());
        console.error();
        throw error;
      }
    },
  };
}
